import React from "react";
import { NavLink } from "react-router-dom";

import "./AppFooter.scss";
import { ROUTES } from "../../utils/constants";
import { AppNavigationRoute } from "../layouts/AppLayout/types";
import useAuth from "../../hooks/useAuth";
import { checkOs } from "../../utils/helpers";
import { OperatingSystems } from "../../utils/vendor";
import { usePwaContext } from "../../context/pwa-context";

interface NavItemProps {
  routeInfo: AppNavigationRoute;
  userIsLoggedIn: boolean;
}

function NavItem({ routeInfo, userIsLoggedIn }: NavItemProps) {
  const { icon: Icon, name, href, isProtected, badge } = routeInfo;

  return (
    <NavLink
      to={!userIsLoggedIn && isProtected ? ROUTES.ROOT.LOG_IN : href}
      className="nav-item"
    >
      {({ isActive }) => (
        <>
          <div className="nav-icon-wrapper">
            <Icon data-active={isActive} />
            {!!badge && <span className="nav-badge">{badge}</span>}
          </div>
          <span data-active={isActive}>{name}</span>
        </>
      )}
    </NavLink>
  );
}

function AppFooter({ routes }: { routes: AppNavigationRoute[] }) {
  const os = checkOs();
  const { isLoggedIn: userIsLoggedIn } = useAuth();
  const { userIsInPwa } = usePwaContext();

  return (
    <footer
      className={`nav-footer MobileOnly ${os === OperatingSystems.Ios ? "Ios" : ""} ${
        userIsInPwa ? "Pwa" : ""
      }`}
    >
      {routes.map((route) => (
        <NavItem
          key={route.name}
          routeInfo={route}
          userIsLoggedIn={userIsLoggedIn}
        />
      ))}
    </footer>
  );
}

export default AppFooter;
